<template>
	<div id="modal-economypost-edit">
		<div class="dimmer" @click="onDimmerClick"></div>
		<div class="popup">
			
			<div class="cols cols-3">							

				<inputfield>
					<label>Kunde</label>
					<select name="" id="" v-model="economypost.client_key">
					<option value="">Ingen relevant kunde</option>
					<option value="" v-for="(client,key,i) in clients" :value="key">
						{{client.name}}						
					</option>
					</select>
				</inputfield>

				<inputfield>
					<label>Opgave</label>
					<select name="" id="" v-model="economypost.project_key">
					<option value="">Ingen relevant opgave</option>
					<option value="" v-for="(project,key,i) in projects" :value="key">
						{{project.name}}
						<template v-if="project.client_key && clients[project.client_key]">
						- {{clients[project.client_key].name}}
						</template>
					</option>
					</select>
				</inputfield>

				<inputfield v-if="!economypost.project_key || !economypost.project_key.length">
					<label>Titel</label>
					<input type="text" v-model="economypost.title">            
				</inputfield>
				
				<inputfield>
					<label>Beløb eks. moms</label>
					<input type="number" min="0" v-model.number="economypost.amount_dkk_ex_vat">
					<p v-if="false && economypost.project_key">
						Project budget:<br>
						{{ outputMoney(getProjectBudgetTotal(getProject(economypost.project_key)),'a') }}
					</p>
				</inputfield>

				<inputfield>
					<label>Faktureringsdato</label>
					<input type="date" v-model="economypost.invoice_date">
				</inputfield>

				<inputfield>
					<label>Note</label>
					<input type="text" v-model="economypost.note">
				</inputfield>	

				<inputfield>
					<label>Faktura #</label>
					<input type="text" v-model.number="economypost.invoice_no">            
				</inputfield>		

				<inputfield>
					<label>Betalingsfrist</label>
					<input type="date" v-model="economypost.payment_due_date">
				</inputfield>

				<div class="checkbox">
					<input type="checkbox" v-model="economypost.invoiced" id="kj12bfds3kj">
					<label for="kj12bfds3kj">Faktureret</label>
				</div>

				<div class="checkbox">
					<input type="checkbox" v-model="economypost.paid" id="fdsdf">
					<label for="fdsdf">Betalt</label>
				</div>

				<div class="checkbox">
					<input type="checkbox" v-model="economypost.hypothetic" id="jn2jkhb">
					<label for="jn2jkhb">Hypotetisk</label>
				</div>

			</div>

			<br>

			<div class="cols cols-3">			


				<btn block color="secondary" @click.native="archiveEconomypost()">Slet</btn>

				<div>&nbsp;</div>

				<btn block color="primary" @click.native="save()">Gem</btn>

			</div>

			<br><br>

			<box :label="'Kommentarer'" v-if="false">
				<comments :keytype="'economypost'" :keyis="economypost['.key']" />
			</box>

			<div class="killer" @click="close()">X</div>
		</div>
	</div>
</template>

<script>
import fdb from '.././firebase_config.js';
import mixins from '../mixins.js'
import helpers from '../helpers.js'
import Inputfield from '.././components/Inputfield'
import Comments from '.././components/Comments'
//import Box from '.././components/Box'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
export default {
	mixins: [ mixins.db, mixins.generic ],
	components: { Inputfield, Btn, Comments, Box },
	data() {
		return {
			app: window.globalAppData,
			globals: globals,
			//user: auth.getUser(),
			closeOnDimmerClick: true,			
		}
	}, // data
	computed: {

		economypost(){ return globals.modal_economypost_edit.economypost },
		
		projects(){ return this.$store.state.firebase.projects },
		clients(){ return this.$store.state.firebase.clients },

	},
  	methods: {

		getProjectBudgetTotal: helpers.getProjectBudgetTotal,
		getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,
		outputMoney: helpers.outputMoney,

		onDimmerClick(){
			if( this.closeOnDimmerClick ) this.close()
		},

		close(){
			globals.modal_economypost_edit.active = false
		},

		
		save()
		{
			var key = this.economypost['.key']
			var economypost = this.economypost

			//console.log(economypost)
			
			var patch = {
				client_key: economypost.client_key,
				project_key: economypost.project_key,
				title: economypost.title,
				note: economypost.note,
				amount_dkk_ex_vat: economypost.amount_dkk_ex_vat,
				invoice_date: economypost.invoice_date,
				invoiced: economypost.invoiced,
				payment_due_date: economypost.payment_due_date,
				invoice_no: economypost.invoice_no,
				paid: economypost.paid,
				hypothetic: economypost.hypothetic,
			}

			if( patch.project_key ) patch.client_key = null // if related to project, then project is related to client. double ref would allow dangerous redundancy. what if a project changed client? there would be a mismatch

			patch = JSON.parse(JSON.stringify(patch)) // no undefined values allowed by firebase

			//console.log(key); console.log(patch); return
			
			fdb.ref('economyposts').child(key).update(patch)

			globals.modal_economypost_edit.active = false
			globals.modal_economypost_edit.timelog = undefined
			eventBus.$emit('toast', {text:'Økonomipost opdateret'})
		},

		archiveEconomypost()
		{
			var confirmed = confirm('Sikker?')
			if( !confirmed ) return
			fdb.ref('economyposts').child(this.economypost['.key']).update({ archived:true })
			globals.modal_economypost_edit.active = false
			globals.modal_economypost_edit.timelog = undefined
			eventBus.$emit('toast', {text:'Økonomipost føjet til papirkurven'})
		},

		getProject(key){ return this.$store.getters['projects/getProject'] },
		

	}, //methods
	mounted(){
		var economypost = JSON.parse(JSON.stringify( globals.modal_economypost_edit.economypost ))
		this.$set( globals.modal_economypost_edit, 'economypost', economypost )		
	},

}
</script>



// WEBPACK FOOTER //
// modal-economypost-edit.vue?536e4ac1